import React from 'react'
import { useSelector } from 'react-redux';
import { Badge, Descriptions, Button, Input, message, Form, } from "antd";
import Select from "react-select";
import { useTheme } from '../../utils/themeToggle/theme';
import { isNumberCheck } from '../../utils/service/formValidation';

const CompanyDetails = ({
    company,
    editedCompany,
    editMode,
    isEdtBaCurr,
    allCurrency,
    countries,
    states,
    companyID,
    handleEdit,
    handleInputChange,
    handleCurrencyChange,
    handleCountryChange,
    handleAdress1Change,
    handleAddress2Change,
    handleCityChange,
    handlePinChange,
    handleStateChange,
    handleCancel,
}) => {
    const select = useSelector((state) => state.auth);
    const user_role = select.userInfo.role;
    const { darkMode } = useTheme();
    return (
        <div>
            <div className=" text-black pb-3 px-2 flex items-center justify-between">
                <span>
                    <h1 className="font-semibold text-[15px] pt-[1%] dark:text-white">
                        Company Details
                    </h1>
                </span>

                {((user_role && user_role.toLowerCase() === "admin") ||
                    user_role.toLowerCase() === "superadmin") &&
                    !editMode ? (
                    <Button
                        type=""
                        style={{
                            border: "1px solid #4E36A3",
                            color: "#4E36A3",
                            height: "40px",
                            width: "120px",
                        }}
                        onClick={handleEdit}
                    >
                        Edit
                    </Button>
                ) : null}
            </div>

            <Descriptions
                title=""
                layout="vertical"
                size="small"
                className="text-[12px] [&_.ant-descriptions-item-label]:text-[11px] [&_.ant-descriptions-item-content]:text-[12px] [&_.ant-descriptions-item]:p-[3px]"
                bordered
            >
                <Descriptions.Item label="Company Name" span={2}>
                    {editMode && editedCompany ? (
                        <Input
                            name="name"
                            value={editedCompany.name}
                            onChange={handleInputChange}
                        />
                    ) : (
                        company.name
                    )}
                </Descriptions.Item>
                <Descriptions.Item label="Base Currency" span={2}>
                    {editMode && !isEdtBaCurr && editedCompany ? (
                        <Select
                            options={allCurrency}
                            onChange={handleCurrencyChange}
                            defaultValue={allCurrency.find(
                                (currency) => currency.value === company.currency
                            )}
                        />
                    ) : (
                        company.currency
                    )}
                </Descriptions.Item>
                <Descriptions.Item label="Active Status">
                    {!company.is_active ? (
                        <Badge color="red" status="" text="Inactive" />
                    ) : (
                        <Badge status="success" text="Running" />
                    )}
                </Descriptions.Item>
                <Descriptions.Item label="Admin's Name">
                    {company.name_of_admin}
                </Descriptions.Item>
                <Descriptions.Item label="Admin's Contact Number">
                    {editMode && editedCompany ? (
                        <Input
                            name="admin_contact_number"
                            value={editedCompany.admin_contact_number}
                            onChange={(e) => {
                                if (isNumberCheck(e.target.value)) {
                                    handleInputChange(e);
                                    return;
                                }
                                message.error("Please enter only numerical value.");
                            }}
                        />
                    ) : (
                        company.admin_contact_number
                    )}
                </Descriptions.Item>
                <Descriptions.Item label="Admin's Email">
                    {company.admin_email || "-"}
                </Descriptions.Item>
                <Descriptions.Item label="Company License No.">
                    <Form.Item
                        name="name"
                        style={{ marginBottom: 0 }}
                    >
                        {editMode && editedCompany ? (
                            <Input
                                onChange={handleInputChange}
                                value={editedCompany.cin}
                                name="cin"
                                defaultValue={editedCompany.cin}
                            />
                        ) : (
                            company.cin || "-"
                        )}
                    </Form.Item>
                </Descriptions.Item>
                <Descriptions.Item label="Company's Contact Number">
                    {editMode && editedCompany ? (
                        <Input
                            name="contact_no"
                            value={editedCompany.contact_no}
                            onChange={(e) => {
                                if (isNumberCheck(e.target.value)) {
                                    handleInputChange(e);
                                    return;
                                }
                                message.error("Please enter only numerical value.");
                            }}
                        />
                    ) : (
                        company.contact_no || "-"
                    )}
                </Descriptions.Item>
                <Descriptions.Item label="TAX License No.">
                    <Form.Item
                        name="gst_number"
                        style={{ marginBottom: -4 }}
                    >
                        {editMode && editedCompany ? (
                            <Input
                                onChange={handleInputChange}
                                value={editedCompany.gst_number}
                                name="gst_number"
                                defaultValue={editedCompany.gst_number}
                            />
                        ) : (
                            company.gst_number || "-"
                        )}
                    </Form.Item>
                </Descriptions.Item>
                <Descriptions.Item label="Domain">
                    {company.domain || "-"}
                </Descriptions.Item>
                <Descriptions.Item label="Number of Licence">
                    {company.number_of_licence || "-"}
                </Descriptions.Item>
                <Descriptions.Item label="Total Users">
                    {company.user_count || "-"}
                </Descriptions.Item>
            </Descriptions>

            <Descriptions
                title="Full Address"
                layout="vertical"
                size="small"
                className="mt-4 text-[12px] [&_.ant-descriptions-item-label]:text-[11px] [&_.ant-descriptions-item-content]:text-[12px] [&_.ant-descriptions-item]:p-[6px] !mb-[-10px]"
                bordered

            >
                <Descriptions.Item label="Address Line 1">
                    {editMode && editedCompany ? (
                        <>
                            <Input
                                name="address1"
                                defaultValue={editedCompany.address.address1}
                                onChange={handleAdress1Change}
                            />
                        </>
                    ) : (
                        company.address.address1 || "-"
                    )}
                </Descriptions.Item>
                <Descriptions.Item label="Address Line 2">
                    {editMode && editedCompany ? (
                        <Input
                            name="address2"
                            defaultValue={editedCompany.address.address2}
                            onChange={handleAddress2Change}
                        />
                    ) : (
                        company.address.address2 || "-"
                    )}
                </Descriptions.Item>
                <Descriptions.Item label="City">
                    {editMode && editedCompany ? (
                        <Input
                            name="city"
                            defaultValue={editedCompany.address.city}
                            onChange={handleCityChange}
                        />
                    ) : (
                        company && company.address.city || "-"
                    )}
                </Descriptions.Item>
                <Descriptions.Item label="PIN">
                    {editMode && editedCompany ? (
                        <Input
                            name="postal_code"
                            defaultValue={editedCompany.address.postal_code}
                            onChange={handlePinChange}
                        />
                    ) : (
                        company && company.address.postal_code || "-"
                    )}
                </Descriptions.Item>

                <Descriptions.Item label="Country">
                    {editMode && editedCompany ? (
                        <Select
                            options={
                                countries &&
                                countries.map((country) => ({
                                    value: country.id,
                                    label: country.name,
                                }))
                            }
                            menuPlacement="top"
                            required
                            onChange={handleCountryChange}
                            defaultValue={
                                company &&
                                company.address.country && {
                                    value: company.address.country.id,
                                    label: company.address.country.name,
                                }
                            }
                            style={{
                                width: "100%",
                            }}
                            optionLabelProp="label"
                            className="custom-select-border dark:bg-black"
                        />

                    ) : (
                        <span

                        >
                            {company?.address?.country?.name || "-"}
                        </span>
                    )}
                </Descriptions.Item>

                {companyID && (
                    <Descriptions.Item label="State">
                        {editMode && editedCompany ? (
                            <Select
                                options={
                                    states &&
                                    states.map((state) => ({
                                        value: state.id,
                                        label: state.name,
                                    }))
                                }
                                menuPlacement="top"
                                onChange={handleStateChange}
                                defaultValue={
                                    company &&
                                    company.address.state && {
                                        value: company.address.state.id,
                                        label: company.address.state.name,
                                    }
                                }
                                style={{

                                    width: "100%",
                                }}
                            />
                        ) : (
                            <span
                                style={{
                                    color: darkMode ? "#ffffff" : "#000000",
                                }}
                            >
                                {company?.address?.state?.name || "-"}
                            </span>
                        )}
                    </Descriptions.Item>
                )}
            </Descriptions>

            {editMode && editedCompany && (
                <div className="flex mt-6">
                    <Button onClick={handleCancel} className="">
                        Cancel
                    </Button>
                    <Button
                        type="primary"
                        htmlType="submit"
                        className="ml-12"
                    >
                        Save
                    </Button>
                </div>
            )}
        </div>
    )
}

export default CompanyDetails;